/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schnuppertagdatum1Inputs */

const de__field_schnuppertagdatum1 = /** @type {(inputs: _Field_Schnuppertagdatum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnuppertag Datum`)
};

/**

* @param {_Field_Schnuppertagdatum1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schnuppertagdatum1 = /** @type {((inputs?: _Field_Schnuppertagdatum1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schnuppertagdatum1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schnuppertagdatum1(inputs)
});
export { _field_schnuppertagdatum1 as "_field_schnuppertagDatum" }